import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  #lastAutoOpenAt = 0;
  #lastAutoOpenKey = '';
  #lastAutoOpenSourceId = '';

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = (event) => {
    if (this.hasAttribute('auto-open')) {
      const primaryDrawer = document.querySelector('cart-drawer-component[auto-open]');
      if (primaryDrawer && primaryDrawer !== this) return;

      const source = event?.detail?.data?.source || '';
      const isCartAddSource = source === 'product-form-component' || source === 'cart-recommended-product';
      if (!isCartAddSource) return;

      if (event?.detail?.data?.didError) return;

      const sourceId = String(event?.detail?.sourceId || '');
      const itemCount = String(event?.detail?.data?.itemCount || '');
      const variantOrProductId = String(event?.detail?.data?.variantId || event?.detail?.data?.productId || '');
      const key = `${source}|${sourceId}|${itemCount}|${variantOrProductId}`;
      const now = Date.now();

      if (this.#lastAutoOpenKey === key && now - this.#lastAutoOpenAt < 1000) return;

      // Extra guard for duplicated cart events from the same source/form firing in sequence.
      if (this.#lastAutoOpenSourceId === sourceId && now - this.#lastAutoOpenAt < 350) return;

      this.#lastAutoOpenKey = key;
      this.#lastAutoOpenSourceId = sourceId;
      this.#lastAutoOpenAt = now;

      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
